<div (click)="close()" class="d-flex flex-column justifiy-content-center align-items-center" style="width: 100%; background-color: white">
  <!-- <button *ngIf="!isMobile" class="close-btn" (click)="close()" ><span class="fa fa-x"></span></button>  -->
  <h2 class="p-2" style="font-size: 1.25rem; border-bottom: 1px solid #00000097; width: 100%; text-align: center" *ngIf="title">{{ title }}</h2>

  <div style="word-wrap: break-word; background-color: var(--white); font-size: 1rem; text-align: justify; width: 100%; text-transform: capitalize; font-weight: 400" *ngIf="descr" class="p-2">"{{ descr }}"</div>

  @if(cropInformation){
  <div style="width: 100%; aspect-ratio: 1/1">
    <app-cropped-image [imgSrc]="imageSrc" class="w-100" [cropInformation]="cropInformation"></app-cropped-image>
  </div>
  } @else{

  <img loading="lazy" (click)="$event.stopPropagation()" [src]="imageSrc" style="width: 100%; object-fit: cover" />
  }
</div>
